import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { IconCircleCheck } from '@calendly/ui/components/glyphs/IconCircleCheck'
import { Link } from '@calendly/ui/components/link'
import { Popup, Body, Footer } from '@calendly/ui/components/popup'
import { UiIcon } from '@calendly/ui/components/ui-icon'
import { colorSurfaceSuccess } from '@calendly/ui/theme'
import { zIndexModal } from '@calendly/ui/z-index'

import {
  Message,
  ConfirmationHeader,
  ConfirmationTitle
} from './styles'

const HelpCenterLink = ({ children }) => (
  <Link href="https://calendly.com/help/how-to-block-someone-from-booking-with-you" target="_blank" rel="noopener noreferrer">
    {children}
  </Link>
)

export const BlockConfirmationModal = ({ onClose, onBlockSuccess, isPast }) => {
  const handleClose = () => {
    if (onBlockSuccess) {
      onBlockSuccess()
    }
    onClose()
  }

  const title = isPast
    ? I18n.t('publisher.block_invitee.success_modal.title_attendee')
    : I18n.t('publisher.block_invitee.success_modal.title_invitee')

  return (
    <Popup
      onClose={handleClose}
      zIndex={zIndexModal}
    >
      <Body>
        <ConfirmationHeader>
          <UiIcon icon={IconCircleCheck} size="large" color={colorSurfaceSuccess} />
          <ConfirmationTitle>
            {title}
          </ConfirmationTitle>
        </ConfirmationHeader>
        <Message>
          {HtmlParser(I18n.t('publisher.block_invitee.success_modal.message'), { HelpCenterLink })}
        </Message>
      </Body>
      <Footer>
        <Button
          wide
          decoration="primary"
          onClick={handleClose}
        >
          {I18n.t('publisher.action.ok')}
        </Button>
      </Footer>
    </Popup>
  )
}
